let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cKUbk")).then(() => parcelRequire('aRTCP'));